'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var rxjs = require('rxjs');
var operators = require('rxjs/operators');

/**
 * Build a stream that can be reset.
 * Source: https://stackoverflow.com/questions/51145664/resetting-replaysubject-in-rxjs-6
 *
 * The idea is to wrap the stream with a sink subject and a source subject.
 * The sink subject passes any data that is published to its stream to the inner stream.
 * The source subject switches its stream to the inner stream so that subscriber
 * can receive data from the inner stream. When the inner stream need to be reset,
 * it is disposed and recreated. The sink subject will pass data to this new inner stream
 * and the source subject switches its stream to this new inner stream.
 *
 * @export
 * @template T
 * @param {() => Subject<T>} factory
 * @returns {ResettableStream<T>}
 */
function resettable(factory) {
  var sink = new rxjs.Subject();
  var source = new rxjs.Subject();
  var destination = factory(); // create the inner stream.
  var subscription = sink.subscribe(destination); // pass data to inner stream.

  return {
    reset: function reset() {
      subscription.unsubscribe();
      destination = factory();
      subscription = sink.subscribe(destination);
      source.next(); // switch to new inner stream.
    },
    subject: sink,
    observable: source.asObservable().pipe(operators.startWith(undefined), operators.switchMap(function () {
      return destination;
    }) // switch to inner stream.
    )
  };
}

exports.resettable = resettable;
